import { gql } from '@apollo/client';

export type PollAnswerCheck = {
  pollAnswers: { documentId: string }[];
};

export const getPollAnswersForUser = gql`
  query GetPollAnswersForUser($email: String!, $pollId: ID!) {
    pollAnswers(
      filters: {
        user: { email: { eq: $email } }
        and: { pollOption: { poll: { documentId: { eq: $pollId } } } }
      }
    ) {
      documentId
    }
  }
`;
